// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"fb421275","829":"b465fc81","878":"48234eec","913":"7fb07e60"}[chunkId] + ".chunk.js";
};